export class DocumentParameterDto {
    searchText: string;
    communityId: number;
    customerId: string;
    category: string;
    subCategory: string;
    month: number;
    year: number;
    clearCache = false;

    constructor(
        customerId?: string,
        communityId?: number,
        category?: string,
        subCategory?: string,
        month?: number,
        year?: number
    ) {
        this.communityId = communityId;
        this.customerId = customerId;
        this.category = category;
        this.subCategory = subCategory;
        this.month = month;
        this.year = year;
    }

    getQueryString(): string {
        let urlStr = `?communityId=${this.communityId}&clearCache=${this.clearCache}`;
        if (!!this.searchText) {
            urlStr += `&searchText=${this.searchText}`;
        }
        if (!!this.customerId) {
            urlStr += `&customerId=${this.customerId}`;
        }
        if (!!this.category) {
            urlStr += `&category=${this.category}`;
        }
        if (!!this.subCategory) {
            urlStr += `&subcategory=${this.subCategory}`;
        }
        if (!!this.month) {
            urlStr += `&month=${this.month}`;
        }
        if (!!this.year) {
            urlStr += `&year=${this.year}`;
        }

        return urlStr;
    }
}
